export default __webpack_public_path__ + "static/media/notif_article_news_subscribed.8d51f55f.svg";